import * as Yup from "yup";

const prestadorServicoValidator = Yup.object().shape({
  profissao: Yup.string().required(),
  grupoPessoas: Yup.array().nullable(),
});

export default prestadorServicoValidator;
